import actions from './actions';

const ClaimSettingDisbursementTimeModule = {
  namespaced: true,
  actions,
};

export default ClaimSettingDisbursementTimeModule;
